import script from "./mentors.vue?vue&type=script&setup=true&lang=js"
export * from "./mentors.vue?vue&type=script&setup=true&lang=js"

import "./mentors.vue?vue&type=style&index=0&id=2e52d933&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e52d933"]])

export default __exports__